export default __webpack_public_path__ + "static/media/make-it-so.db577a49.png";